import { checkIsResellerTenant } from 'swag-common/utils/check-is-reseller-tenant.util';
import { ACH, NET_15, NET_30, NET_45, NET_60, UPFR_50_NET_15, UPFR_50_NET_30 } from 'swag-common/constants/payment-methods';
export const getHasResellerOrderNetOrACHPaymentMethod = orderData => {
  if (!(orderData !== null && orderData !== void 0 && orderData.paymentMethod)) {
    return false;
  }
  const isResellerOrder = (orderData === null || orderData === void 0 ? void 0 : orderData.tenant) && checkIsResellerTenant(orderData.tenant);
  return Boolean(isResellerOrder) && [ACH, NET_15, NET_30, NET_45, NET_60, UPFR_50_NET_15, UPFR_50_NET_30].includes(orderData.paymentMethod);
};